import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContentPaperEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "content-paper-edit" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.627,14.87,15,22.5l-3.75.75L12,19.5l7.631-7.63a2.113,2.113,0,0,1,2.991,0l.009.008A2.116,2.116,0,0,1,22.627,14.87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.246,20.25h-6a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.5,1.5V9"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.246,
			y1: 5.25,
			x2: 14.246,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.246,
			y1: 9.75,
			x2: 14.246,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.246,
			y1: 14.25,
			x2: 12.746,
			y2: 14.25
		})
	]
});
export default SvgContentPaperEdit;
